import { Button, Flex, Group, Paper } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { ClickableSectionTitle } from 'src/UI/page-nav/ClickableSectionTitle';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { SquareIconButton } from './SquareIconButton';

type Props = {
  title: string;
  isEditing: boolean;
  onToggleEdit: () => void;
  canSave: boolean;
  isSaving: boolean;
  children: ReactNode;
};

export function IndividualSectionCard({
  title,
  isEditing,
  onToggleEdit,
  canSave,
  isSaving,
  children,
}: Props) {
  return (
    <Paper variant="content-section">
      <Group justify="space-between" mb="xl" align="center">
        <ClickableSectionTitle fw={FONT_WEIGHTS.bold} size="xl" data-testid="section-label">
          {title}
        </ClickableSectionTitle>
        {isEditing ? (
          <Flex gap="xs">
            <Button variant="default" onClick={onToggleEdit} data-testid="toggle-edit-button">
              Cancel
            </Button>
            <Button data-testid="save-button" type="submit" disabled={!canSave} loading={isSaving}>
              Save
            </Button>
          </Flex>
        ) : (
          <SquareIconButton
            diameter={40}
            radius={12}
            onClick={onToggleEdit}
            aria-label="Edit section"
            data-testid="toggle-edit-button"
          >
            <IconPencil size={20} color="var(--mantine-color-gray-8)" />
          </SquareIconButton>
        )}
      </Group>
      {children}
    </Paper>
  );
}
